export default {
    title: "Lar",
    button: {
        accessories: "Navegar no catálogo"
    },
    noAvailableItems: "Não há produtos disponíveis para encomenda.",
    error: "Ocorreu um problema ao recuperar os produtos. Atualize seu navegador."
}